// src/utils/phone.ts

// Константа для читаемости
export const ARM_CC = '374' as const;

// Оставляет только цифры
export const digitsOnly = (s: string) => (s || '').replace(/\D/g, '');

// Красивый вывод: "+374 XX XXX XXX" (без круглых скобок и с устойчивостью к любым вводам)
export function formatAmPhoneDisplay(input?: string): string {
  const d = digitsOnly(input || '');
  if (!d) return '';

  const fmt = (eight: string) => `+${ARM_CC} ${eight.slice(0, 2)} ${eight.slice(2, 5)} ${eight.slice(5, 8)}`;

  // уже с кодом страны
  if (d.startsWith(ARM_CC)) {
    const rest = d.slice(ARM_CC.length);
    if (rest.length >= 8) return fmt(rest.slice(0, 8));
    return `+${ARM_CC} ${rest}`;
  }

  // ведущий 0 перед локальным номером
  if (d.startsWith('0')) {
    const rest = d.slice(1);
    if (rest.length >= 8) return fmt(rest.slice(0, 8));
  }

  // «голые» 8 цифр → форматируем как +374 XX XXX XXX
  if (d.length === 8) return fmt(d);

  // если цифр больше 8 — берём последние 8 (устойчивость к мусору)
  if (d.length > 8) return fmt(d.slice(-8));

  // иначе просто вернём то, что есть
  return d;
}

// Маска показа: + (374) XX XX XX XX (для поля ввода)
export function formatAmPhoneMasked(input: string): string {
  const dAll = digitsOnly(input);

  // убираем код страны/ведущий 0 → оставляем только "локальные" цифры
  let local = dAll;
  if (local.startsWith(ARM_CC)) local = local.slice(ARM_CC.length);
  else if (local.startsWith('0')) local = local.slice(1);

  // берём последние 8 цифр (устойчиво к мусору)
  const last8 = local.slice(-8);
  const p = (s: string, a: number, b: number) => s.slice(a, b);

  if (last8.length <= 2)  return `+ (${ARM_CC}) ${p(last8,0,2)}`;
  if (last8.length <= 4)  return `+ (${ARM_CC}) ${p(last8,0,2)} ${p(last8,2,4)}`;
  if (last8.length <= 6)  return `+ (${ARM_CC}) ${p(last8,0,2)} ${p(last8,2,4)} ${p(last8,4,6)}`;
  return `+ (${ARM_CC}) ${p(last8,0,2)} ${p(last8,2,4)} ${p(last8,4,6)} ${p(last8,6,8)}`;
}

// Нормализация к E.164 для хранения/отправки
export function normalizeAmPhone(input: string): string {
  const d = digitsOnly(input);
  if (!d) return '';

  // случаи: "+374XXXXXXXX", "374XXXXXXXX"
  if (d.startsWith(ARM_CC)) {
    const rest = d.slice(ARM_CC.length);
    const last8 = rest.slice(-8);
    return last8.length === 8 ? `+${ARM_CC}${last8}` : '';
  }

  // случай: "0XXXXXXXX" или просто "XXXXXXXX"
  const last8 = d.slice(-8);
  return last8.length === 8 ? `+${ARM_CC}${last8}` : '';
}
